import { Link } from "react-router-dom";
import { useContent } from "@/hooks/useContent";

const Footer = () => {
  const { data: site } = useContent("/content/site.json");
  return (
    <footer data-testid="site-footer" className="border-t border-[#232638] bg-[#08090C]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-5">
          <p className="font-display text-2xl font-extrabold uppercase tracking-tighter">
            Ronaldo <span className="text-amber-400">DJ</span>
          </p>
          <p className="mt-3 text-sm text-zinc-500 font-light max-w-xs">
            Freestyle, Charme, Funk e Hip-Hop — 24h no ar na Web Rádio Clássicos do Funk.
          </p>
        </div>
        <div className="col-span-6 md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4">Navegar</p>
          <nav className="flex flex-col gap-2.5">
            <Link to="/#radio" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">A Rádio</Link>
            <Link to="/#sets" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">Sets</Link>
            <Link to="/#agenda" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">Agenda</Link>
            <Link to="/blog" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">Blog</Link>
            <Link to="/#contato" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">Contato</Link>
          </nav>
        </div>
        <div className="col-span-6 md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4">Redes</p>
          <div className="flex flex-col gap-2.5">
            {(site?.socials || []).map((s) => (
              <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-[#232638]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © 2026 Ronaldo DJ — Clássicos do Funk
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Site estático — rápido, seguro e sem servidor
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
